<!--  -->
<template>
  <div class="login">
    <div class="top-title">大兴生物医药产业基地智慧化危险废物管理平台</div>

    <div class="center">
      <div class="center-main">
        <login v-if="page === 'login'" @linkTo="linkTo"></login>
        <register v-if="page === 'register'" @linkTo="linkTo"></register>
        <forgetPwd v-if="page === 'forgetPwd'" @linkTo="linkTo"></forgetPwd>
      </div>
    </div>
    <div class="foot-support">技术支持单位：北京益普希环境咨询顾问有限公司</div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Slider from "@/components/Slider";
import { Notification } from "element-ui";
import login from "./components/login.vue";
import register from "./components/register.vue";
import forgetPwd from "./components/forgetPwd.vue";
export default {
  name: "",
  //import引入的组件需要注入到对象中才能使用
  components: { Slider, login, register, forgetPwd },
  data() {
    // var validateVerifyCode = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请输入验证码"));
    //   } else if (this.identifyCode.toLowerCase() !== value.toLowerCase()) {
    //     callback(new Error("验证码有误!"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      page: "login",
      version: new Date().valueOf(),
      commonDatas: [],
      userTest: false,
      menuType: 1,
      // identifyCode: "",
      // loginForm: {
      //   name: "",
      //   password: "",
      //   verifycode: "",
      //   deviceToken: "",
      //   isDebug: true,
      // },
      rememberPwd: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    linkTo(page) {
      this.page = page;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
/* @import url(); 引入公共css类 */
/* @import url("../../assets/css/common.css"); */
.login {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: url("./../../assets/newImages/loginbj.png") no-repeat;
  background-size: 100% 100%;

  .top-title {
    font-size: 24px;
    color: #ffffff;
    padding: 20px 30px;
  }

  .el-textarea__inner,
  .el-input__inner {
    background-color: transparent !important;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #d9d9d9;
    color: #000000;
    padding-left: 40px;
  }

  .el-input__icon {
    color: #3a61d7;
    font-weight: bold;
    padding-right: 20px;
  }

  .nav-top {
    font-size: 22px;
    color: #141720;
    padding: 12px 0;
    margin: 20px;
    padding-left: 220px;
    padding-right: 30px;

    .login-icon {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      margin-right: 20px;
    }
  }

  .center {
    width: 100%;
    min-height: 500px;
    margin-top: 160px;

    // background-image: linear-gradient(170deg, #1597f9 3%, #035ed3 91%);
    .center-main {
      width: 1248px;
      margin: 0 auto;
      display: flex;

      .el-input {
        font-size: 14px;
      }

      .center-box {
        width: 427px;
        height: 480px;
        position: relative;
        // background: url("./../../assets/newImages/mimabj.png") no-repeat;
        background: #ffffff;
        background-size: 100% 100%;
        text-align: center;
        margin: auto;
        padding-left: 15px;
        padding-top: 16px;
        padding: 60px;
        border-radius: 2px;
      }

      .login-tit {
        font-size: 20px;
        margin: 20px 20px 40px 20px;
        font-weight: bold;
        font-weight: 800;
        color: #000;

        span {
          border-bottom: 1.5px solid #466cda;
          padding-bottom: 5px;
        }
      }

      .rememberPwd {
        text-align: left;

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #3a61d7;
          border-color: #3a61d7;
        }
      }

      .center-box-footer {
        display: flex;
        justify-content: space-between;

        .link {
          color: #3a61d7;
          cursor: pointer;
        }
      }
    }
  }

  .foot-support {
    position: fixed;
    bottom: 10px;
    left: 10px;
    color: #fff;
  }
}
</style>
